import { useTranslation } from "react-i18next";
import CommonHeading from "../../../../Components/CommonHeading";
import { useStudentLessonAcquitationStore } from "../../../../Store/GroupManagement/StudentLessonAcqusitationStore";
import MonthSelector from "./Select";
import TableHead from "./TableHead";

export default function Heading() {
  const { months, branches, subjects } = useStudentLessonAcquitationStore();
  const optionsMonths =
    months?.map((element) => ({
      label: element.name,
      value: element.month,
    })) || [];

  const optionsBranches =
    branches?.map((element) => ({
      label: element.title,
      value: element.id,
    })) || [];

  const optionsSubjects =
    subjects?.map((element) => ({
      label: element.name,
      value: element.id,
    })) || [];
  const { t } = useTranslation();
  return (
    <CommonHeading
      topItems={
        <>
          <MonthSelector options={optionsMonths} property={t("Oylar")} />
          <MonthSelector options={optionsBranches} property={t("Filiallar")} />
          <MonthSelector options={optionsSubjects} property={t("Fanlar")} />
        </>
      }
      tableHead={<TableHead />}
    />
  );
}
